export enum TypeContractEnum {
	ACCOUNT_CREATION = "ACCOUNT_CREATION",
	ANTICIPATION_CONTRACT = "ANTICIPATION_CONTRACT",
	VIVO_PAY_AWARD = "VIVO_PAY_AWARD",
}
